import { IAPIResponseCustomerCare } from 'affiny-core/modules/api/models/customerCare/customerCare.type';
import { AffinyEndpoint } from '../affinyEndpoints/affiny.endpoints';

export const CustomerCareResource = {
  getFAQ: async (appVersion: string) =>
    AffinyEndpoint.CustomerCare.url(`/faq_link?appVersion=${appVersion}`)
      .get()
      .json<IAPIResponseCustomerCare>(),
};
